module.exports = __webpack_public_path__ + "img/ic-alert.d2eb6e6d.svg";